import React, { useState, useEffect } from 'react';
import { makeRequest } from '../../utils/httpRequest';
import Config from '../../core/config';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import {
    formatDateStringToString,
    formatDateTimeToString,
    parseLocalDate,
    UserPermission
} from '../../utils/utils';
import Loading from '../../core/Loading';
import DatePicker from "react-datepicker";
import {handleInputChange} from "../../utils/stateInputUtils";
import {usePermission} from "../../core/PermissionContext";

const apiUrl = Config.apiUrl;

const PrescriptionList = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const [prescriptions, setPrescriptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [queryForm, setQueryForm] = useState({
        searchTerm: '',
        startDate: undefined,
        endDate: undefined,
        status: 'ALL'
    });
    const navigate = useNavigate();

    useEffect(() => {
        fetchPrescriptions();
    }, []);

    async function removePrescription(id) {

        try {
            setLoading(true);
            const url = apiUrl + '/api/prescriptions/' + id;
            await makeRequest(url, 'DELETE', {'Useruuid': Cookies.get('userUUID')});
            await fetchPrescriptions();
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }

    }

    async function printLabel(id) {
        const userUUID = Cookies.get('userUUID');
        const url = apiUrl + '/api/prescriptions/' + id + '/print';
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'useruuid': userUUID,
            }
        });
        if(response.ok) {
            setPrescriptions(prev =>
                prev.map(item =>
                    item.id === id ? { ...item, status: 'PRINTED' } : item
                )
            );
        }

    }

    function fetchPrescriptions() {
        const { searchTerm, startDate, endDate, status } = queryForm;
        let url = `${apiUrl}/api/prescriptions?search=${searchTerm}`;

        console.log('startDate:', startDate);
        console.log('endDate:', endDate);
        if (startDate) {
            url += `&startDate=${startDate}`;
        }
        if (endDate) {
            url += `&endDate=${endDate}`;
        }
        if (status && status !== 'ALL') {
            url += `&status=${status}`;
        }

        makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')})
            .then(response => {
                setPrescriptions(response);
            })
            .catch(error => {
                console.error('Erro ao buscar prescrições:', error);
            });
    }



    if (loadingPermissions) {
        return <Loading></Loading>;
    }

    if( !hasUserPermission(UserPermission.LIST_PRESCRIPTION)) {
        navigate('/unauthorizedaccess');
    }

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div className="header-label">Prescrições</div>
                {hasUserPermission(UserPermission.CREATE_PRESCRIPTION) && (
                    <button className="new-button" onClick={() => navigate('/app/prescription')}>Nova</button>
                )}
            </div>
            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', width: '100%'}}>

                <div style={{marginTop: '5px', alignItems: 'center', display: "flex"}}>
                    <div style={{alignItems: 'center'}}>
                        Paciente/Instituição/Medicamento
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <input type="text" style={{width:'300px'}} value={queryForm.searchTerm} onChange={(e) => handleInputChange(e.target.value, 'searchTerm', setQueryForm)}/>
                        </div>
                    </div>
                    <div style={{flexDirection: "column", alignItems: 'center'}}>
                        Data (Lançamento/Receita):
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <DatePicker
                                className="datepicker"
                                selected={parseLocalDate(queryForm.startDate)}
                                onChange={(e) => handleInputChange(e, 'startDate', setQueryForm, 'DATE')}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                autoComplete="off"
                            />

                            até
                            <DatePicker
                                className="datepicker"
                                selected={parseLocalDate(queryForm.endDate)}
                                onChange={(e) => handleInputChange(e, 'endDate', setQueryForm, 'DATE')}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div style={{flexDirection: "column", alignItems: 'center'}}>

                        Status
                        <div style={{display: 'flex', alignItems: 'center'}}>

                            <select value={queryForm.status}
                                    onChange={(e) => handleInputChange(e.target.value, 'status', setQueryForm)}>
                                <option key="ALL" value="ALL">
                                    Todos
                                </option>
                                <option key="TYPED" value="TYPED">
                                    Digitados
                                </option>
                                <option key="PRINTED" value="PRINTED">
                                    Impressos
                                </option>
                            </select>

                            <button onClick={fetchPrescriptions}>Consultar</button>
                        </div>
                    </div>

                </div>

            </div>

            {loading ? <Loading/> : (
                <table style={{width: '100%', borderCollapse: 'collapse'}}>
                    <thead>
                    <tr>
                        <th>Código</th>
                        <th>Paciente</th>
                        <th>Instituição</th>
                        <th>Lançamento</th>
                        <th>Receita</th>
                        <th>Medicamentos</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {prescriptions.map((prescription) => (
                        <tr key={prescription.id}>
                            <td>{prescription.code}</td>
                            <td>{prescription.patientName}</td>
                            <td>{prescription.nursingHome}</td>
                            <td>{formatDateTimeToString(new Date(prescription.createdDate))}</td>
                            <td>{formatDateStringToString(prescription.prescriptionDate)}</td>
                            <td>{prescription.medications.map(m => m.medication).join(', ')}</td>
                            <td>{prescription.status === 'PRINTED' ? 'Impresso' : 'Digitado'}</td>
                            <td>
                                <button
                                    onClick={async () => await printLabel(prescription.id)}>Imprimir
                                </button>
                                {hasUserPermission(UserPermission.EDIT_PRESCRIPTION) && (
                                    <button className="edit-button"
                                        onClick={() => navigate(`/app/prescription?id=${prescription.id}`)}>Editar</button>
                                )}

                                {hasUserPermission(UserPermission.REMOVE_PRESCRIPTION) &&
                                    <button className="remove-button" onClick={async () => {
                                        // eslint-disable-next-line no-restricted-globals
                                        if (window.confirm('Deseja realmente excluir?')) {
                                            await removePrescription(prescription.id);
                                        }
                                    }}>Excluir
                                    </button>
                                }
                            </td>
                        </tr>
                    ))}
                    </tbody>
                    {prescriptions.length === 0 && <tfoot>
                    <tr>
                        <td colSpan="6">Nenhuma prescrição encontrada.</td>
                    </tr>
                    </tfoot>}
                </table>
            )}
        </>
    );
};

export default PrescriptionList;
